import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

import Header from "../layout/Header";
import Flashmessages from "../flashMessagesComp/flashMessages";
import { API_CONSTANTS } from "../../shared/constants/api.constants";
import Loader from "../common/GlobalLoader";

import {
  sendFlashMessage,
  clearcurrentFlashMessage,
} from "../../actions/flashMessage";


class AddEditSectors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      description: "",
      externalId: "",
      loading: false,
      isAddForm: props.data && props.data.add,
      id: this.props.match.params.id
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    if (!this.state.isAddForm && this.state.id) {
      this.loadSector()
    }
  }

  loadSector() {
    this.setState({ loading: true })
    axios
      .get(`${API_CONSTANTS.COUNCIL.GET_WCEA_SECTOR(this.state.id)}`)
      .then((res) => {
        this.setState({
          name: res.data.name || "",
          description: res.data.description || "",
          externalId: res.data.externalId || "",
          id: res.data.id,
          loading: false
        })
        this.props.sendFlashMessage(
          "Sector fetched successfully !!",
          "alert-success"
        )
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000)
      })
      .catch((err) => {
        this.setState({ loading: false })
        this.props.sendFlashMessage(
          "Something went wrong !!",
          "alert-danger"
        )
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000)
      })
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit(e) {
    e.preventDefault()
    if (this.validateForm()) {
      this.setState({ loading: true })
      if (this.state.isAddForm) {
        this.addSector()
      } else {
        this.updateSector()
      }
    }
  }

  addSector() {
    this.setState({ loading: true })
    axios
      .post(`${API_CONSTANTS.COUNCIL.ADD_WCEA_SECTORS}`, {
        name: this.state.name,
        description: this.state.description,
        externalId: this.state.externalId
      })
      .then((res) => {
        this.setState({
          name: "",
          description: "",
          externalId: "",
          loading: false
        })
        this.props.sendFlashMessage(
          "Sector Created successfully !!",
          "alert-success"
        )
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000)
        this.props.history.push("/sectors");
      })
      .catch((err) => {
        this.setState({ loading: false })
        this.props.sendFlashMessage(
          "Something went wrong !!",
          "alert-danger"
        )
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000)
      })
  }

  updateSector() {
    this.setState({ loading: true })
    axios
      .put(`${API_CONSTANTS.COUNCIL.UPDATE_WCEA_SECTORS(this.state.id)}`, {
        name: this.state.name,
        description: this.state.description,
        externalId: this.state.externalId
      })
      .then((res) => {
        this.setState({
          loading: false
        })
        this.props.sendFlashMessage(
          "Sector Updated successfully !!",
          "alert-success"
        )
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000)
        this.props.history.push("/sectors");
      })
      .catch((err) => {
        this.setState({ loading: false })
        this.props.sendFlashMessage(
          "Something went wrong !!",
          "alert-danger"
        )
        setTimeout(() => {
          this.props.clearcurrentFlashMessage();
        }, 2000)
      })
  }

  validateForm() {
    if (!this.state.name) {
      this.props.sendFlashMessage(
        "Please enter Sector name",
        "alert-danger"
      )
      setTimeout(() => {
        this.props.clearcurrentFlashMessage()
      }, 2000)
      return false
    }
    return true
  }

  render() {
    return (
      <section class="wrapper">
        <Header />
        <section class="">
          <Flashmessages />
          <div class="container-fluid">
            <div class="spacetb25">
              <nav class="breadcrumb__list">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    {" "}
                    <Link to="/organisation">Organisation</Link>
                  </li>
                  <li class="breadcrumb-item">
                    {" "}
                    <Link to="/sectors">Sectors</Link>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    {this.state.isAddForm ? "Add Sector" : "Edit Sector"}
                  </li>
                </ol>
              </nav>
              <div class="row">
                <div class="col-xl-8 offset-xl-2">
                  <form onSubmit={this.onSubmit} encType="multipart/form-data">
                    <div class="card card__custom">
                      <div class="card-header">
                        <h5 class="card-title">*= Required Fields</h5>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class={`form-group textbox__label`}>
                              <label>Name *</label>
                              <input
                                type="text"
                                class="form-control"
                                onChange={this.onChange}
                                id="name"
                                placeholder="Enter Sector name"
                                name="name"
                                value={this.state.name}
                                required
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class={`form-group textbox__label`} >
                              <label>Description</label>
                              <textarea
                                className="form-control"
                                onChange={this.onChange}
                                id="description"
                                placeholder="Enter Description"
                                name="description"
                                value={this.state.description}
                                rows="4"
                              />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class={`form-group textbox__label`} >
                              <label>External ID</label>
                              <input
                                type="text"
                                className="form-control"
                                onChange={this.onChange}
                                id="externalId"
                                placeholder="Enter External ID"
                                name="externalId"
                                value={this.state.externalId}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer text-center">
                        <button type="submit" class="btn btn-secondary">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Loader loadStatus={this.state.loading} />
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
})

export default connect(mapStateToProps, {
  sendFlashMessage,
  clearcurrentFlashMessage,
})(withRouter(AddEditSectors))

